import { ProjectMembersActionTypes } from "../types";

type ActionInfo = {
    projectId: number;
    forceReload?: boolean;
};

export type LoadProjectMembers = ReturnType<typeof loadProjectMembers>;
export const loadProjectMembers = (payload: ActionInfo) => ({
    type: ProjectMembersActionTypes.GET_PROJECT_MEMBERS,
    ...payload,
});
